import classNames from "classnames";

import styles from "./ModeButton.module.css";

interface ModeButtonProps {
  isActive: boolean;
  onClick: () => void;
}

/**
 * A button for selecting a collaboration mode in the collapsed bar.
 * Displays vertical text and highlights when active.
 */
export function ModeButton({
  children,
  isActive,
  onClick,
}: React.PropsWithChildren<ModeButtonProps>) {
  return (
    <button
      className={classNames(styles.modeButton, {
        [styles.active]: isActive,
      })}
      onClick={onClick}
      aria-pressed={isActive}
    >
      <span className={styles.verticalText}>{children}</span>
    </button>
  );
}
